export default {
  id: 129,
  title: 'Target #129 - Letter B',
  url: 'https://cssbattle.dev/play/129',
  colors: ['#6592CF', '#515DBD', '#2E3B9F', '#060F55'],
  solution:
    '<a><style>body{background:#6592cf}a{position:fixed;top:80;left:110;width:100;height:80;border-radius:0 9in 9in 0;background:#060f55;box-shadow:0 60px #060f55,40px 0 #2e3b9f,40px 60px #2e3b9f,80px 0 #515dbd,80px 60px #515dbd}</style>',
}
